export default function Hamburger() {
    return {
        restrict: "E",
        scope: {},
        template: require("./template.html"),
        controller: function ($scope, $aside, siteService) {
            /**
             * [openAside description]
             * @param  {[type]} $event           [description]
             * @param  {[type]} position         [description]
             * @param  {[type]} backdrop         [description]
             * @param  {[type]} declinedBookings [description]
             * @param  {[type]} repeatedBooking  [description]
             * @return {[type]}                  [description]
             */
            $scope.openAside = function (
                $event,
                position,
                backdrop,
                declinedBookings,
                repeatedBooking
            ) {
                var template = "aside-left.html";

                if (position == "right") {
                    template = "aside-right.html";
                }
                $scope.asideState = siteService.asideState = {
                    open: true,
                    position: position,
                };

                var asideInstance = $aside.open({
                    template: require("../../aside/" + template),

                    placement: position,
                    size: "sm",
                    controller: "asideController",
                    backdrop: backdrop,
                    openedClass: "modal-aside modal-open",
                    resolve: {
                        declinedBookings: function () {
                            //var someVar = someVar; // but nice to keep for later use

                            if (declinedBookings) {
                                return declinedBookings;
                            }
                        },
                        repeatedBooking: function () {
                            if (repeatedBooking) {
                                return repeatedBooking;
                            }
                        },
                    },
                });

                asideInstance.result.then(
                    function () {
                        // avail param : selectedItem
                        // $scope.selected = selectedItem;
                        // console.log($scope.selected);
                    },
                    function () {
                        $scope.asideState.open = siteService.asideState.open = false;
                        // console.info('modal-component dismissed at: ' + new Date());
                    }
                );
                // function postClose() {}
            };
        },
    };
}
